// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ng-0";
export var assigneeDetails = "_ng-1";
export var assigneeInfo = "_ng-2";
export var dropdownContainer = "_ng-4";
export var dropdownImage = "_ng-5";
export var editAssigneeInfo = "_ng-3";
export var editAssigneeModalContainer = "_ng-6";
export var hidden = "_ng-8";
export var input = "_ng-7";